"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PROGRAM_MANAGER_PROGRAM_ID = exports.DEFAULT_MULTISIG_PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.DEFAULT_MULTISIG_PROGRAM_ID = new web3_js_1.PublicKey("SMPLecH534NA9acpos4G6x7uf3LWbCAwZQE9e8ZekMu");
exports.DEFAULT_PROGRAM_MANAGER_PROGRAM_ID = new web3_js_1.PublicKey("SMPLKTQhrgo22hFCVq2VGX1KAktTWjeizkhrdB1eauK");
